export default __webpack_public_path__ + "static/media/twitter.8adc75c9.png";